export const GET_TRANSFER_TRANSACTION_REQUEST =
  'GET_TRANSFER_TRANSACTION_REQUEST';
export const GET_TRANSFER_TRANSACTION_SUCCESS =
  'GET_TRANSFER_TRANSACTION_SUCCESS';
export const GET_TRANSFER_TRANSACTION_FAILURE =
  'GET_TRANSFER_TRANSACTION_FAILURE';
export const GET_DOLLAR_TRANSACTION_REQUEST = 'GET_DOLLAR_TRANSACTION_REQUEST';
export const GET_DOLLAR_TRANSACTION_SUCCESS = 'GET_DOLLAR_TRANSACTION_SUCCESS';
export const GET_DOLLAR_TRANSACTION_FAILURE = 'GET_DOLLAR_TRANSACTION_FAILURE';
